module.exports = __webpack_public_path__ + "media/images/cny-logo-nav-7db10174aa6ea5ad4c90212f31ae9b97.svg";